<template>
<div>
    <h2><i class="fa fa-fw fa-lg fa-text-width"></i> Zusatztext</h2>
    <p></p>
    <div class="v-form-partial">
        <div class="v-form">
            <fieldset>
                <section>
                    <label class="label">Wird am unteren Ende der Rechnung angedruckt</label>
                    <label class="textarea">
                        <textarea rows="10" name="invoice_additional_text"><?= $this->invoice_additional_text ?></textarea>
                    </label>
                </section>
            </fieldset>
        </div>
    </div>
</div>
</template>
<script>
export default {
    //
}
</script>
